/**
 * 元数据打印工具 — 打印当前 VM 页面的 meta 元数据，方便开发调试
 *
 * 控制台使用：
 *   ttx.debug.meta()               // 打印当前 VM 的完整 template 元数据
 *   ttx.debug.meta(true)           // 精简模式，仅打印关键字段
 *   ttx.debug.meta(false, key)     // 按 key 打印指定 VM 的元数据
 */
window.ttx = window.ttx || {};
ttx.debug = ttx.debug || {};

(function () {
    /**
     * 打印当前 VM 的 meta 元数据
     *
     * @param {boolean} [compact=false] - 是否精简模式，仅打印关键字段
     * @param {string}  [key]           - 指定 VM 的 key，不传则取当前活跃 VM
     */
    ttx.debug.meta = function (compact, key) {
        var vm;
        if (key && typeof ttx.debug.getVM === 'function') {
            vm = ttx.debug.getVM(key);
        } else if (typeof ttx.debug.getCurrentVM === 'function') {
            vm = ttx.debug.getCurrentVM();
        }

        if (!vm) {
            ttx.console.warn('[META] 没有可用的 VM，请先打开一个页面');
            return;
        }

        var template = vm._get_data?.('template');
        if (!template) {
            ttx.console.warn('[META] 当前 VM 没有 template 元数据');
            return;
        }

        ttx.console.log('========== VM Meta ==========');
        ttx.console.log('serviceCode:', vm._get_data?.('serviceCode') || '?');
        ttx.console.log('currentMode:', vm._get_data?.('currentMode') || '?');
        ttx.console.log('pageMode:', vm._get_data?.('pageMode') || '?');

        if (compact) {
            // 精简模式：只打印关键信息
            var compactInfo = {
                cCardKey: template.view?.cCardKey,
                title: template.view?.title || template.view?.cCaption,
                templateType: template.view?.templateType,
                layout: template.view?.layout,
                panes: template.view?.panes?.length,
                tabs: template.view?.tabs?.length,
            };
            ttx.console.log('template (compact):', JSON.stringify(compactInfo, null, 2));
            ttx.console.log('params:', JSON.stringify(vm.getParams?.() || {}, null, 2));
            ttx.console.log('==============================');
            return;
        }

        // 完整模式：打印完整 template 和 params
        ttx.console.log('template:', template);
        ttx.console.log('params:', vm.getParams?.());
        ttx.console.log('==============================');
    };
})();
